import { render, staticRenderFns } from "./VCarCard.vue?vue&type=template&id=4ecc8b38"
import script from "./VCarCard.vue?vue&type=script&lang=js"
export * from "./VCarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports